import './helpers.js';
import './config.js';
import { b as registerComponent, u as use } from './plugins-f72cbfce.js';
import './Icon-311893d1.js';
import './FormElementMixin-97156cdb.js';
import './Input-3186e79f.js';
import './MatchMediaMixin-58956a9c.js';
import './trapFocus-25a621e6.js';
import './DropdownItem-d781f273.js';
import './Select-0b09003c.js';
import { _ as __vue_component__ } from './Timepicker-ea2af49d.js';
export { _ as BTimepicker } from './Timepicker-ea2af49d.js';

const Plugin = {
  install(Vue) {
    registerComponent(Vue, __vue_component__);
  }

};
use(Plugin);

export default Plugin;
